import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import SEOHead from "@/components/site/SEOHead";

const PATH_TO_PAGE = {
  "/": "home",
  "/assurances-professionnelles": "assurances-pro",
  "/sante-prevoyance": "sante-prevoyance",
  "/patrimoine-placements": "patrimoine",
  "/methode": "methode",
  "/partenaires": "partenaires",
  "/contact": "contact",
  "/mentions-legales": "mentions-legales",
};

export default function SiteLayout() {
  const location = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [location.pathname]);

  const pageKey = PATH_TO_PAGE[location.pathname] || "home";

  return (
    <div className="min-h-screen bg-ducs-night text-ducs-cream flex flex-col">
      <SEOHead pageKey={pageKey} />
      <Header />
      <main className="flex-1 pt-28">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
